function Form() {
    return (
        <form method="get" className="form">
            <div>
                <input type="text" name="form-prenom" id="form-prenom" placeholder="Prénom" required />
                <input type="text" name="form-nom" id="form-nom" placeholder="Nom de famille" required />
            </div>
            <div>
                <input type="email" name="form-email" id="form-email" placeholder="E-mail" required />
                <input type="tel" name="form-phone" id="form-phone" placeholder="Téléphone" required />
            </div>
            <textarea name="form-message" id="form-message" placeholder="Commentaires" required></textarea>
            <button type="submit">Envoyer</button>
        </form>
    )
}

export default Form;